import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: ":studentId",
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "student-transcript-details" */ "./components"
    ).then(m => m.default)
  ),

  childRoutes: [],
});
